/*****************************************************************************************************************************************************
 * Key performance indicator monitoring *
 ****************************************************************************************************************************************************/
define('commons/monitoring/kpi-monitoring',['jquery', 'commons/monitoring/base-monitoring'], function($, BaseMonitoring) {

    var KPIMonitoring = function() {
        // Call parent init method
        BaseMonitoring.apply(this, arguments);
    };

    // Inherit from MessageMonitoring
    for ( var element in BaseMonitoring.prototype) {
        KPIMonitoring.prototype[element] = BaseMonitoring.prototype[element];
    }

    KPIMonitoring.prototype.processResponse = function(result) {
        var lastTime = result.lastTime;
        var step = result.step;
        var data = [];
        var labels = ["Time"];

        var tmpData = [];
        // Keys and labels of a given mapping key have the same length
        for (var k = 0; k < this.mapping.keys.length; k++) {
            tmpData.push(result.data[this.mapping.keys[k]]);
            labels.push(this.mapping.labels[k]);
        }
        if (tmpData.length > 0) {
            // Data from a given mapping key have the same length
            for (var i = 0; i < tmpData[0].length; i++) {
                var dataRow = [];
                for (var j = 0; j < tmpData.length; j++) {
                    dataRow[j] = (tmpData[j][i] == "NaN" ? 0 : tmpData[j][i]);
                }
                var date = new Date();
                date.setTime(lastTime - step * (tmpData[0].length - 1 - i));
                data.push($.merge([date], dataRow));
            }
        }

        var drawOptions = $.extend({
            stepPlot: true
        }, this.drawOptions);

        return {
            data: data,
            labels: labels,
            drawOptions: drawOptions
        };
    };
    return KPIMonitoring;
});
